import React from 'react';
import Navbar from '../../components/navbar';
import Refund from './Refund';
const Product = () => {
  return (
    <React.Fragment>
      <Navbar isBlack={true} />
      <Refund />
    </React.Fragment>
  );
};

export default Product;
